export enum DocumentStep {
    All = 0,
    Urgent,
    Additional
}
